import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";
import { graphql } from "gatsby";
import React from "react";

import {
  Container,
  Content,
  FaqItem,
  FaqItemAnswer,
  FaqItemQuestion,
  HeadlineContainer,
  Link,
  QAContainer,
  TagContainer,
  TagContent,
} from "./MordorFaqBlock.styles";

export interface MordorFaqBlockProps extends Queries.SanityMordorFaqBlock {}

const MordorFaqBlock: React.FC<MordorFaqBlockProps> = ({
  headline,
  tagText,
  faqItems,
}) => (
  <Container>
    <Content>
      <HeadlineContainer>
        <TagContainer>
          <TagContent>
            <Text variant="L4" weight="medium">
              {tagText}
            </Text>
          </TagContent>
        </TagContainer>
        <Text variant="H3" as="h3" weight="medium">
          {headline}
        </Text>
      </HeadlineContainer>

      {faqItems?.map((faqItem) => {
        if (!faqItem) return null;

        return (
          <QAContainer key={faqItem.question}>
            <FaqItem>
              <FaqItemQuestion>
                <Text variant="H5" as="h5" weight="medium">
                  {faqItem.question}
                </Text>
              </FaqItemQuestion>
              <FaqItemAnswer>
                <RichText variant="B2" text={faqItem._rawAnswer} />
              </FaqItemAnswer>
            </FaqItem>
            {faqItem.button?.url && faqItem.button?.label && (
              <Link href={faqItem.button.url}>
                <Button
                  variant={faqItem.button.variant as ButtonVariant}
                  label={faqItem.button.label}
                />
              </Link>
            )}
          </QAContainer>
        );
      })}
    </Content>
  </Container>
);

export const query = graphql`
  fragment MordorFaqBlock on SanityMordorFaqBlock {
    _key
    _type
    headline
    tagText
    faqItems {
      _key
      question
      _rawAnswer(resolveReferences: { maxDepth: 5 })
      button {
        variant
        label
        url
      }
    }
  }
`;

export default MordorFaqBlock;
